import React from 'react'
import BooksDetail from '../books/BooksDetail'
import { ELibraryCategory } from '../../enum/elibrary_enum'

type Props = {}

const EbooksDetail: React.FC<Props> = ({ }: Props) => {
    return (
        <BooksDetail
            library_category={ELibraryCategory.E_BOOK}
        />
    )
}

export default EbooksDetail